const runtimeConfig = window.__APP_CONFIG__ || {};

const trimTrailingSlash = (value) => {
  if (!value) return "";
  return value.replace(/\/+$/, "");
};

const rooturl = trimTrailingSlash(
  runtimeConfig.rooturl ||
    runtimeConfig.ROOT_URL ||
    runtimeConfig.API_ROOT_URL ||
    runtimeConfig.API_BASE_URL ||
    "https://localhost:7050",
).replace(/\/api\/?$/i, "");

const baseurl = trimTrailingSlash(
  runtimeConfig.baseurl ||
    runtimeConfig.BASE_URL ||
    runtimeConfig.APP_URL ||
    "http://localhost:3000",
);

const legecityDocumentPath =
  runtimeConfig.legecity_document_path ||
  runtimeConfig.legacy_document_path ||
  runtimeConfig.LEGECITY_DOCUMENT_PATH ||
  runtimeConfig.LEGACY_DOCUMENT_PATH ||
  "C:\\oldpath\\Documents";

const primarySite = trimTrailingSlash(
  runtimeConfig.primarySite ||
    runtimeConfig.PRIMARY_SITE ||
    baseurl,
);

const appConfig = {
  // Same names as public/config.js
  ENV: runtimeConfig.ENV || "local",
  rooturl,
  baseurl,
  legecity_document_path: legecityDocumentPath,
  primarySite,
  pay4it_key: runtimeConfig.pay4it_key || "TEST-Key-670664575316be1f4dc68994",
  paystack_public:
    runtimeConfig.paystack_public ||
    "pk_test_657c8b8312c24ace7419a954beac2b8f4c43e65f",

  // Lowercase/backward-compatible aliases
  env: runtimeConfig.ENV || "local",
  apiBaseUrl: rooturl + "/api",
  appUrl: baseurl,
  legacyDocumentUrl: legecityDocumentPath,
  caseDocumentUrl:
    runtimeConfig.caseDocumentUrl ||
    runtimeConfig.CASE_DOCUMENT_URL ||
    rooturl + "/api/document/download",
};

export default appConfig;
